import React, { Component } from 'react';
import SideBar from '../SideBar/SideBar';
import '../TicketBooking/TicketBooking.css'
import { toast } from 'react-toastify';
import Loader from '../Components/Utils/AnLoader/Loader'
import Swal from 'sweetalert2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
import axios from "../Constant/axios"
export default class AirlineMaster extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            AirlineMasterData: [],
            serialNo: 1,
            selectedRowToEdit: []

        };

    }

    componentDidMount() {
        // var login = localStorage.getItem("token")
        // if (login === null || login === undefined) window.location.href = "/";
        this.getAirlineDetail();

    }

    componentWillUnmount() {
       
    }
    getAirlineDetail = () => {
        debugger
        axios.get(`/getAirlineDetail`).then((res) => {
            if (res && res.data && res.data.data) {
                res.data.data.forEach(e => {
                    e.isDisabled = true
                });
                this.setState({ AirlineMasterData: res.data.data, loading: false, });
            } else {
                this.setState({ AirlineMasterData: [], loading: false, });
            }
        },
            (err) => {
                console.log(err);
            }
        );
    }

    handleCityName = (cell, val,name) => {
        debugger
        this.setState(prevState => ({
            AirlineMasterData: prevState.AirlineMasterData.map(item => {
                if (item.srno && item.srno === cell.srno) {
                    return {
                        ...item,
                        [name]: val, // Use computed property name to update dynamically
                        cr_by: this.state.userId,
                        isUpdated: true
                    };
                }
                return item;
            })
        }));
    }

    HandleAddNewRow = () => {
        let AirlineMasterData = this.state.AirlineMasterData
        let newJob = {
            temp_id: AirlineMasterData.length + 1,
            srno: AirlineMasterData.length + 1,
            code :"",
            name :"",
            iata_no :"",
            commision_perc_inr :"",
            commision_perc_usd :"",
            is_domestic :"",
            disable_cpn_chk :"",
            contact_no :"",
            address :"",

        }
        AirlineMasterData.unshift(newJob)
        this.setState({ AirlineMasterData })
    }


    handledit = (cell, e) => {
        this.setState({ selectedRowToEdit: [] })

        var selectedRowToEdit = this.state.selectedRowToEdit
        selectedRowToEdit.push(cell)
        this.setState({ selectedRowToEdit })

        this.state.selectedRowToEdit.forEach(e => {
            e.isDisabled = false
        });
    }

    handleDeleteRecord = (cell) => {
        var TicketData = []

        var selectedRow = {
            Srno: cell.srno,
            id: cell.id,
            del_by: this.state.userId,
            isUpdated: true
        }
        TicketData.push(selectedRow)

        let masterData = {
            data: TicketData
        }

        Swal.fire({
            title: 'Are you sure you want to delete?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DB4444',
            cancelButtonText: 'No',
            confirmButtonText: 'Yes',
        }).then((result) => {
            if (result.isConfirmed) {
                const options = this.state.AirlineMasterData.filter((item) => {
                    return item.srno !== cell.srno
                })


                this.setState({ AirlineMasterData: options })
                Swal.fire(
                    'Deleted!',
                    'Your Data has been Deleted.',
                    'success'
                )

            } else {

            }
        }).catch((error) => {
            // Handle error
        });
    }

    handleDataSave = () => {
        debugger
        var AirlineMasterData = [];
        for (var i = 0; i < this.state.AirlineMasterData.length; i++) {

            if (this.state.AirlineMasterData[i].isUpdated === true) {
                if (this.state.AirlineMasterData[i].city_name === "" || this.state.AirlineMasterData[i].city_name === "") {
                    toast.error(`Please fill in input fields in Row No. ${this.state.AirlineMasterData[i].srno}`)
                    return false;
                }

                AirlineMasterData.push(this.state.AirlineMasterData[i])
            }
        }
        if (AirlineMasterData.length > 0) {
            AirlineMasterData = { data: AirlineMasterData }

            this.setState({ loading: true })

            axios.post(`/saveAirlineDetail`, AirlineMasterData).then((res) => {
                if(res.data.success === "success"){
                Swal.fire({
                    icon: "success",
                    title: "Your data has been saved in below table",
                    showConfirmButton: false,
                    timer: 2000
                });
                this.getAirlineDetail()
            }
               
            })
        
        }
        else {
            Swal.fire({
                icon: "error",
                title: "No any new data in above table",
                showConfirmButton: false,
                timer: 2000
            });
        }
    }
    render() {

        return (
            // this.state.loading ? <Loader /> :
            <div className="container-fluid">
                <div className="row mt-2">
                    <div className="col-md-2">
                        <SideBar ScreenName={"Airline Master"} />
                    </div>
                    <div className="col-md-10">
                        <div className="container h-100 poDetailsContainer_media" style={{ marginTop: "73px", backgroundColor: "#f9fbfd", width: "96%", marginLeft: "34px" }}>
                            <div className="row m-0 p-0 align-items-center justify-content-center mb-3">
                                <div className="col-md-6 mt-3">
                                    <h4 className='FontB'><b>Airline Master</b></h4>
                                </div>
                                <div className="col-md-6 mt-2 m-0 p-0 text-end mt-3">
                                    <button onClick={() => this.HandleAddNewRow()} className="btn-sm  buttonBorder me-2" style={{ cursor: "pointer" }}>Add New Row</button>

                                    {/* </div>
                                    <div className="col-md-2  mt-3"> */}
                                    <button type="submit" onClick={() => this.handleDataSave()} className="btn-sm buttonBorder2G" style={{ cursor: "pointer", color: 'white' }}>Save</button>
                                    {/* <button  onClick={() => this.getAirlineDetail()} className="btn-sm buttonBorder2G" style={{ cursor: "pointer", color: 'white' }}>Reset</button> */}

                                </div>

                            </div>

                            <div class="table-responsive">
                                {this.state.loading ? <Loader /> :
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th className='thBg' scope="col" >Sr No </th>
                                                <th className='thBg' scope="col" style={{ minWidth: "100px", textAlign: "center" }}>Airline Code</th>
                                                <th className='thBg' scope="col" style={{ minWidth: "100px", textAlign: "center" }}>Airline Name </th>
                                                <th className='thBg' scope="col" style={{ minWidth: "100px", textAlign: "center" }}>IATA No </th>
                                                <th className='thBg' scope="col" style={{ minWidth: "100px", textAlign: "center" }}>Comm % INR</th>
                                                <th className='thBg' scope="col" style={{ minWidth: "100px", textAlign: "center" }}>Comm % USD</th>
                                                <th className='thBg' scope="col" style={{ minWidth: "100px", textAlign: "center" }}>Is Domestic (Y/N)</th>
                                                <th className='thBg' scope="col" style={{ minWidth: "100px", textAlign: "center" }}>Disable CPN CHK</th>
                                                <th className='thBg' scope="col" style={{ minWidth: "100px", textAlign: "center" }}>Contact No.</th>
                                                <th className='thBg' scope="col" style={{ minWidth: "100px", textAlign: "center" }}>Address</th>
                                                <th className='thBg' scope="col" style={{ minWidth: "100px", textAlign: "center" }}>Operations </th>

                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.AirlineMasterData.map((item, index) => (
                                                <tr key={item.line_id}>
                                                    <td style={{ textAlign: "center" }}> {index + 1}</td>
                                                    <td style={{ textAlign: "center" }}> <input className="form-control" type="text" name ="code"  value={item.code} disabled={item.isDisabled} onChange={(e) => this.handleCityName(item, e.target.value,e.target.name)} /></td>
                                                    <td style={{ textAlign: "center" }}> <input className="form-control" type="text" name ="name" value={item.name} disabled={item.isDisabled} onChange={(e) => this.handleCityName(item, e.target.value,e.target.name)} /></td>
                                                    <td style={{ textAlign: "center" }}> <input className="form-control" type="text" name ="iata_no" value={item.iata_no} disabled={item.isDisabled} onChange={(e) => this.handleCityName(item, e.target.value,e.target.name)} /></td>
                                                    <td style={{ textAlign: "center" }}> <input className="form-control" type="text" name ="commision_perc_inr" value={item.commision_perc_inr} disabled={item.isDisabled} onChange={(e) => this.handleCityName(item, e.target.value,e.target.name)} /></td>
                                                    <td style={{ textAlign: "center" }}> <input className="form-control" type="text" name ="commision_perc_usd" value={item.commision_perc_usd} disabled={item.isDisabled} onChange={(e) => this.handleCityName(item, e.target.value,e.target.name)} /></td>
                                                    <td style={{ textAlign: "center" }}> <input className="form-control" type="text" name ="is_domestic" value={item.is_domestic} disabled={item.isDisabled} onChange={(e) => this.handleCityName(item, e.target.value,e.target.name)} /></td>
                                                    <td style={{ textAlign: "center" }}> <input className="form-control" type="text" name ="disable_cpn_chk" value={item.disable_cpn_chk} disabled={item.isDisabled} onChange={(e) => this.handleCityName(item, e.target.value,e.target.name)} /></td>
                                                    <td style={{ textAlign: "center" }}> <input className="form-control" type="text" name ="contact_no" value={item.contact_no} disabled={item.isDisabled} onChange={(e) => this.handleCityName(item, e.target.value,e.target.name)} /></td>
                                                    <td style={{ textAlign: "center" }}> <input className="form-control" type="text" name ="address" value={item.address} disabled={item.isDisabled} onChange={(e) => this.handleCityName(item, e.target.value,e.target.name)} /></td>

                                                    <td style={{ textAlign: "center" }}>
                                                        <FontAwesomeIcon
                                                            icon={faEdit}
                                                            onClick={(e) => this.handledit(item, index, e)}
                                                            style={{ color: "#227446", fontSize: "18px", paddingRight: '9px', cursor: 'pointer' }}
                                                        />
                                                        {item.temp_id &&
                                                            <FontAwesomeIcon
                                                                icon={faTrash}
                                                                onClick={(e) => this.handleDeleteRecord(item, index, e)}
                                                                style={{ cursor: 'pointer', color: "red", borderleft: '1px solid black', paddingleft: '9px', fontSize: "18px", marginLeft: '10px' }}
                                                            />
                                                        }
                                                    </td>

                                                </tr>
                                            ))}
                                            {(this.state.AirlineMasterData.length === 0 &&
                                                <td colSpan={4} style={{ fontFamily: "poppins", textAlign: "center" }}> No Data Present</td>
                                            )}
                                        </tbody>

                                    </table>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

